import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@carbon/react';
import { Add } from '@carbon/react/icons';
import { PageHeader } from 'components/page-header';
import routes from '~/routes';
import { DcaScenariosListContent } from './dca-scenarios-list-content';
import styles from './dca-scenarios-list.module.scss';

export const DcaScenariosListPage: FC = () => {
  const history = useHistory();

  return (
    <>
      <PageHeader
        breadcrumbs={[['/dca_scenarios', 'DCA Scenarios']]}
        title="DCA Scenarios"
        actions={
          <div className={styles.addButton}>
            <Button
              size="md"
              kind="primary"
              renderIcon={Add}
              onClick={() => history.push(routes.newDcaScenarioPath)}
            >
              Add New DCA Scenario
            </Button>
          </div>
        }
      />
      <div className={styles.pageContainer}>
        <div className={styles.pageBody}>
          <DcaScenariosListContent />
        </div>
      </div>
    </>
  );
};
